import { CardProfile } from '@pesto/features/src/Cards/components/CardProfile';
import { useUrlTabs } from '@pesto/hooks';
import { LoadingSpinner } from '@pesto/ui';
import { BreadcrumbComponent } from '@pesto/ui/components/Breadcrumbs/BreadcrumbComponent';
import { Sparkles } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

import { useGetCardByIdQuery } from '../../__generated__/graphql/api';
import { routes } from '../../constants/routes';
import { NotFound } from '../NotFound';
import { toCardDetail } from './toCardDetail';

const CARD_TABS = ['details'];

export const CardDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data, loading } = useGetCardByIdQuery({
    variables: { cardId: id ?? '' },
    skip: !id,
    notifyOnNetworkStatusChange: true,
  });

  const { currentTab, setCurrentTab } = useUrlTabs({
    defaultTab: 'details',
    validTabs: CARD_TABS,
    basePath: `${routes.cards}/${id}`,
  });

  if (loading) {
    return (
      <div className="flex h-96 items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  const cardResult = data?.listCards?.cards?.find((item) => item?.id === id) ?? null;

  if (!cardResult) {
    return <NotFound />;
  }

  const card = toCardDetail(cardResult);

  const owner = card.owner
    ? {
        id: card.owner.id,
        displayName: card.owner.displayName,
        badges: card.owner.isFriendsAndFam ? [{ label: 'Friends & Family', icon: Sparkles }] : undefined,
      }
    : null;

  const ownerDetails = owner ? { id: owner.id, name: owner.displayName } : null;
  const loan = card.loan;

  return (
    <main className="flex flex-1 flex-col gap-4 p-4 md:p-8">
      <BreadcrumbComponent items={[{ label: 'Cards', href: routes.cards }, { label: card.referenceId ?? card.id }]} />
      <CardProfile
        card={card}
        owner={owner}
        loan={loan}
        ownerDetails={ownerDetails}
        currentTab={currentTab}
        onTabChange={setCurrentTab}
        onOwnerClick={() => navigate(routes.users + '/' + owner?.id)}
        onLoanClick={() => navigate(routes.loans + '/' + loan?.id)}
      />
    </main>
  );
};
